// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"HeroBlockSlice_imageContainer__K3jyV","imageDesktop":"HeroBlockSlice_imageDesktop__crtjS","imageMobile":"HeroBlockSlice_imageMobile__YZ8Px"};